import { DatePipe, registerLocaleData } from '@angular/common';
import { ElementRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import localeZh from '@angular/common/locales/zh';
import { Subscription } from 'rxjs';
import { LangUpdateService } from './_services/lang-update.service';

@Pipe({
    name: 'customDate',
    pure: true,
    standalone: false
})
export class CustomDatePipe implements PipeTransform, OnDestroy {

    private curLang = 'en';

    value: string = '';
    lastDate: Date | null = null;
    lastParams: any[] = [];
    onLangChange: Subscription | undefined;

    constructor(private datePipe: DatePipe, private langService: LangUpdateService, private element: ElementRef) {
        registerLocaleData(localeZh, 'zh-CN');
    }

    updateValue(date: Date, interpolateParams: string): void {
        let locale = null;
        if (this.curLang === 'zh') {
            locale = 'zh-CN';
        }

        this.value = this.datePipe.transform(date, interpolateParams, null, locale);
        this.lastDate = date;

        if (this.element.nativeElement.textContent && this.element.nativeElement.textContent !== 'undefined') {
            this.element.nativeElement.textContent = this.value;
        } else {
            this.element.nativeElement.data = this.value;
        }
    }

    transform(query: Date, ...args: string[]): any {
        let locale = null;
        if (this.curLang === 'zh') {
            locale = 'zh-CN';
        }

        if (query === this.lastDate && args === this.lastParams) {
            return this.value;
        }

        let interpolateParams = args[0];
        this.lastDate = query;
        this.lastParams = args;
        this.updateValue(query, interpolateParams);
        this._dispose();
        if (!this.onLangChange) {
            this.onLangChange = this.langService.register(this, (res) => {
                this.curLang = res;
                if (this.lastDate) {
                    this.lastDate = null;
                    this.updateValue(query, interpolateParams);
                }
            });
        }

        return this.value;
    }

    private _dispose(): void {
        if (typeof this.onLangChange !== 'undefined') {
            this.onLangChange.unsubscribe();
            this.onLangChange = undefined;
        }
    }

    ngOnDestroy(): void {
        this._dispose();
    }
}
